import script from "./AssinaturasPage.vue?vue&type=script&setup=true&lang=js"
export * from "./AssinaturasPage.vue?vue&type=script&setup=true&lang=js"

import "./AssinaturasPage.vue?vue&type=style&index=0&id=36f6d041&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-36f6d041"]])

export default __exports__